<template>
  <div  class="column-area">
    <div v-for="oneDetail in detailListData" class="detail-list">
      <div class="detail_title">
        <span class="detail_name">{{resourceName}} {{oneDetail.detailName}} </span>
        <a class="read_btn" @click="clientReadPage(oneDetail)">阅读</a>
      </div>
      <show-img-list :pageData="oneDetail.accessoryList" :showPageNum="showPageNum"></show-img-list>
    </div>
    <!--分页-->
    <div class="paging-set">
      <el-pagination class="pagiing-num"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="queryEntity.current"
                     :page-sizes="[5, 10, 20, 30, 40, 50]"
                     :page-size="queryEntity.sizes"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="queryEntity.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import detailApi from "@/api/detail"
  import showImgList from './showimglist'
  import { Message,MessageBox } from 'element-ui'
  import {confirm,pageParamNames} from '@/utils/constants'

  export default {
    name: "detailList",

    components: {
      showImgList,
    },

    data(){
      return{
        tableLoading: false,
        showPageNum: 9,
        resourceName:"",
        detailListData: [],
        pageData: [],
        queryEntity:{
          keyWord: null,
          current: 1,
          pages: 0,
          sizes: 5,
          total: 0,
          orderField: "useCount",
          extInt: 10,
          extStr:null,
        },
      }
    },
    props: {
      dataList: {
        type: [Object],
      }
    },
    created() {

    },
    mounted() {
      this.queryEntity.sizes = 5;
      this.queryEntity.current = 1;
      this.queryEntity.keyword = this.dataList.categroyGuid;
      this.resourceName = this.dataList.resourceName;
      this.queryEntity.extInt = 10;
      this.queryEntity.extStr = null;
      this.showBookDetailList(this.queryEntity);
    },
    methods:{
      showBookDetailList(queryEntity){
        detailApi.getDetailListByEntity(queryEntity).then(res=>{
          this.detailListData = res.data.data.list;
          console.log(this.detailListData);
          this.yearStatList = res.data.yearStatList;
          this.$parent.yearStatList = this.yearStatList;
          this.tableLoading = false;
          pageParamNames.forEach(name => this.$set(this.queryEntity, name, res.data.data[name]))
        })
      },
      getDetailDataByYear(yearName){
        this.queryEntity.extStr = yearName;
        this.showBookDetailList(this.queryEntity)
      },
      //分页
      handleSizeChange(val) {
        this.queryEntity.sizes = val;
        this.showBookDetailList();
      },
      handleCurrentChange(val) {
        this.queryEntity.current = val;
        this.showBookDetailList();
      },
      clientReadPage(oneDetail){
        let paraObject = {
          resourceName: this.resourceName,
          volumeName: oneDetail.detailName,
          volumeGuid: oneDetail.guid,
          volumeIndexSort: 0
        }
        console.log(paraObject);
        console.log(oneDetail.accessoryList);
        const { href } = this.$router.resolve({
          name: "readpage",
          query: paraObject,
        });
        window.open(href, '_blank');
      }
    }
  }
</script>

<style var="{selectFontSize}" rel="stylesheet/scss" lang="scss" scoped>
@import url('../../styles/common.css');
@import url('../../styles/main.css');
</style>



// WEBPACK FOOTER //
// src/view/readpage/detaillist.vue